import { Paths } from "@/modules/template/common/enum";
import {
  AccountTransferTemplatePage,
  BudgetTransferTemplatePage,
  CardTransferTemplatePage,
  CurrencyExchangeTemplatePage,
  LoanRepaymentTemplatePage,
  OwnTransferTemplatePage,
  TemplatesPage,
} from "@/modules/template/pages";
import { FeatureToggle, SearchParamKeys } from "@/shared/common/enums";
import { FeatureToggleRoute } from "@/shared/components";
import { Layout } from "@/shared/layout";
import { Outlet, type RouteObject } from "react-router-dom";

const generateBreadcrumb = () => {
  const templateName = new URLSearchParams(window.location.search).get(SearchParamKeys.TemplateName);
  return { meta: templateName };
};

export const templateRoutes: RouteObject = {
  path: Paths.Templates,
  element: <Layout/>,
  handle: {
    breadcrumb: () => ({ key: "breadcrumb.templates" }),
  },
  children: [
    {
      element: (
        <FeatureToggleRoute
          featureFlag={FeatureToggle.isTemplatesAvailable}
          element={<Outlet/>}
        />
      ),
      children: [
        {
          path: "",
          element: (
            <FeatureToggleRoute
              featureFlag={FeatureToggle.isTemplatesAvailable}
              element={<TemplatesPage/>}
            />
          ),
        },
        {
          path: Paths.AccountTransferTemplate,
          element: (
            <FeatureToggleRoute
              featureFlag={FeatureToggle.isAccountTransferAvailable}
              element={<AccountTransferTemplatePage/>}
            />
          ),
          handle: {
            breadcrumb: () => generateBreadcrumb()
          }
        },
        {
          path: Paths.AccountTransferTemplateUpdate,
          element: (
            <FeatureToggleRoute
              featureFlag={FeatureToggle.isAccountTransferAvailable}
              element={<AccountTransferTemplatePage isEdit/>}
            />
          ),
          handle: {
            breadcrumb: () => generateBreadcrumb()
          }
        },
        {
          path: Paths.CardTransferTemplate,
          element: (
            <FeatureToggleRoute
              featureFlag={FeatureToggle.isCardTransferAvailable}
              element={<CardTransferTemplatePage/>}
            />
          ),
          handle: {
            breadcrumb: () => generateBreadcrumb()
          }
        },
        {
          path: Paths.CardTransferTemplateUpdate,
          element: (
            <FeatureToggleRoute
              featureFlag={FeatureToggle.isCardTransferAvailable}
              element={<CardTransferTemplatePage isEdit/>}
            />
          ),
          handle: {
            breadcrumb: () => generateBreadcrumb()
          }
        },
        {
          path: Paths.OwnTransferTemplate,
          element: (
            <FeatureToggleRoute
              featureFlag={FeatureToggle.isOwnAccountTransferAvailable}
              element={<OwnTransferTemplatePage/>}
            />
          ),
          handle: {
            breadcrumb: () => generateBreadcrumb()
          }
        },
        {
          path: Paths.OwnTransferTemplateUpdate,
          element: (
            <FeatureToggleRoute
              featureFlag={FeatureToggle.isOwnAccountTransferAvailable}
              element={<OwnTransferTemplatePage isEdit/>}
            />
          ),
          handle: {
            breadcrumb: () => generateBreadcrumb()
          }
        },
        {
          path: Paths.CurrencyExchangeTemplate,
          element: (
            <FeatureToggleRoute
              featureFlag={FeatureToggle.isCurrencyExchangeAvailable}
              element={<CurrencyExchangeTemplatePage/>}
            />
          ),
          handle: {
            breadcrumb: () => generateBreadcrumb()
          }
        },
        {
          path: Paths.CurrencyExchangeTemplateUpdate,
          element: (
            <FeatureToggleRoute
              featureFlag={FeatureToggle.isCurrencyExchangeAvailable}
              element={<CurrencyExchangeTemplatePage isEdit/>}
            />
          ),
          handle: {
            breadcrumb: () => generateBreadcrumb()
          }
        },
        {
          path: Paths.LoanRepaymentTemplate,
          element: (
            <FeatureToggleRoute
              featureFlag={FeatureToggle.isLoanRepaymentAvailable}
              element={<LoanRepaymentTemplatePage/>}
            />
          ),
          handle: {
            breadcrumb: () => generateBreadcrumb()
          }
        },
        {
          path: Paths.LoanRepaymentTemplateUpdate,
          element: (
            <FeatureToggleRoute
              featureFlag={FeatureToggle.isLoanRepaymentAvailable}
              element={<LoanRepaymentTemplatePage isEdit/>}
            />
          ),
          handle: {
            breadcrumb: () => generateBreadcrumb()
          }
        },
        {
          path: Paths.BudgetTransferTemplate,
          element: (
            <FeatureToggleRoute
              featureFlag={FeatureToggle.isBudgetTransferTemplateAvailable}
              element={<BudgetTransferTemplatePage/>}
            />
          ),
          handle: {
            breadcrumb: () => generateBreadcrumb()
          }
        },
        {
          path: Paths.BudgetTransferTemplateUpdate,
          element: (
            <FeatureToggleRoute
              featureFlag={FeatureToggle.isBudgetTransferTemplateAvailable}
              element={<BudgetTransferTemplatePage isEdit/>}
            />
          ),
          handle: {
            breadcrumb: () => generateBreadcrumb()
          }
        },
      ],
    },
  ],
};
